import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Approach from "@/pages/Approach";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentStatus from "@/pages/PaymentStatus";
import CancelEngagement from "@/pages/CancelEngagement";
import ProtectedRoute from "@/components/ProtectedRoute";
import Insights from "@/pages/Insights";
import Assessment from "@/pages/Assessment";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/approach" element={<Approach />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/payment-status" element={<PaymentStatus />} />
          <Route path="/cancel" element={<CancelEngagement />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/assessment" element={<Assessment />} />
        </Routes>
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
